export default {
  note: {
    title: 'Besondere Hinweise:',
    description:
      'Wir geben unser Bestes, um Wünsche zu berücksichtigen, aber können keine Änderungen vornehmen, die den Preis beeinflussen.',
    placeholder: 'Sonderwunsch hinzufügen',
  },
  buttons: {
    update_item: 'Aktualisieren',
    add_to_card: 'Hinzufügen',
    add: '+ Artikel',
  },
  alcohol_warning: 'Dies ist ein Artikel mit Altersbeschränkung.',
  caffeine_warning: 'Erhöhter Koffeingehalt. Für Kinder und schwangere oder stillende Frauen nicht empfohlen.',
  error_messages: {
    missing_fields: 'Bitte wähle alle erforderlichen Felder aus.',
    product_unavailable: 'Ausverkauft!',
  },
  success_messages: {
    item_added: 'Artikel erfolgreich hinzugefügt',
  },
};
